import { graphql } from '../../graphql';

export const createUserCard = graphql(`
  mutation CreateCard {
    createCard {
      redirectUrl
      status
      errors {
        code
        message
        path
      }
    }
  }
`);

export const updateUserCard = graphql(`
  mutation UpdateCard($input: CardUpdateInput!) {
    updateCard(input: $input) {
      card {
        id
        name
        token
        pan
        expiry
        system
        iconUrl
        issuer
        isActive
        isExpired
        isPrimary
      }
      errors {
        code
        message
        path
      }
    }
  }
`);

export const deleteUserCard = graphql(`
  mutation DeleteCard($input: CardDeleteInput!) {
    deleteCard(input: $input) {
      cards {
        id
        name
        token
        pan
        expiry
        system
        iconUrl
        issuer
        isActive
        isExpired
        isPrimary
      }
    }
  }
`);

export const setPrimaryUserCard = graphql(`
  mutation SetPrimaryCard($input: CardSetPrimaryInput!) {
    setPrimaryCard(input: $input) {
      cards {
        id
        name
        isActive
        token
        isPrimary
      }
      errors {
        code
        message
        path
      }
    }
  }
`);
